import { Auth } from "aws-amplify";
import { getGlobals } from "../utils/GlobalThis";

export const signIn = async (email, password) => {
  try {
    const { globalSessionContext, globalStorageContext } = getGlobals();
    const resolve = await Auth.signIn((email || "")?.toLowerCase(), password);
    const jwtToken = resolve?.signInUserSession?.idToken?.jwtToken;
    if (!!jwtToken) {
      globalStorageContext.setLocalStorageItem({
        name: "jwtToken",
        value: jwtToken,
      });
      globalSessionContext.activateSession();
      return Promise.resolve(jwtToken);
    }
    return Promise.reject(new Error("jwtToken not valid"));
  } catch (signInException) {
    return Promise.reject(signInException);
  }
};

export const signOut = async () => {
  try {
    const { globalSessionContext, globalStorageContext } = getGlobals();
    const resolve = await Auth.signOut();
    globalStorageContext.removeLocalStorageItem({ name: "jwtToken" });
    globalStorageContext.removeLocalStorageItem({ name: "profileData" });
    globalSessionContext.deactivateSession();
    return Promise.resolve(resolve);
  } catch (signOutException) {
    return Promise.reject(signOutException);
  }
};